import { render, staticRenderFns } from "./ProductScrollTextCmp.vue?vue&type=template&id=f4101fc2&scoped=true&"
import script from "./ProductScrollTextCmp.vue?vue&type=script&lang=js&"
export * from "./ProductScrollTextCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductScrollTextCmp.vue?vue&type=style&index=0&id=f4101fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4101fc2",
  null
  
)

export default component.exports